import React from 'react';
import { Dropdown, Menu, Modal } from 'antd';
import Api from '../../../../services/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import { Flex, Avatar, useUserinfo } from '@mss/mss-component-library';
import { TFunction } from 'i18next';

export default function UserGroupColumns(
  t: TFunction,
  fetchGroupMembers: () => void
) {
  const [hasPermission] = useUserinfo();
  return [
    {
      title: '',
      dataIndex: 'name',
      key: 'name',
      width: 30,
      render: (a: any) => {
        return (
          <Flex h="center" v="center">
            <Avatar firstName={a[0]} lastName={a[1]} />
          </Flex>
        );
      },
    },
    {
      title: t('Group'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '',
      dataIndex: 'relationId',
      key: 'relationId',
      width: 40,
      align: 'center',
      render: (record: any, all: any) => {
        return (
          <span
            style={{ width: 24, display: 'block' }}
            onClick={e => e.stopPropagation()}
          >
            {hasPermission(['delete_usergroup']) && !all.system_id && (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      onClick={() => {
                        Modal.confirm({
                          title: t('Remove user from group'),
                          icon: (
                            <span className="anticon">
                              <FontAwesomeIcon
                                icon={faExclamationTriangle}
                                color="#fd9644"
                                size="sm"
                              />
                            </span>
                          ),
                          content: t(
                            `You're about to remove the user from the group '(GROUP)'. Are you sure?`,
                            { allName: all.name }
                          ),
                          onOk: async () => {
                            await Api.group.user.remove(record);
                            fetchGroupMembers();
                          },
                        });
                      }}
                    >
                      {t('Delete')}
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
              >
                <div style={{ width: 24 }}>
                  <FontAwesomeIcon icon={faEllipsisV} />
                </div>
              </Dropdown>
            )}
          </span>
        );
      },
    },
  ];
}
